import React from "react";
import { ClassNameProps, isRGBColorLight, makeClassName, StyleProps } from "@hex-insights/core";
import { Icon } from "../../../../Components/Icon";
import { UserGroup } from "../../../../Utilities";
import styles from "./styles.module.css";

export type IconUserGroup = Pick<UserGroup, "color">;

export type UserGroupIconProps = {
	userGroup: IconUserGroup;
	size?: number;
	title?: string;
} & Partial<ClassNameProps & StyleProps>;

export function UserGroupIcon({ userGroup, size, title, className, style }: UserGroupIconProps) {
	const ref = React.useRef<HTMLDivElement | null>(null);
	const [iconColor, setIconColor] = React.useState("#fff");
	React.useLayoutEffect(() => {
		if (!ref.current) {
			return;
		}
		const backgroundColor = getComputedStyle(ref.current).backgroundColor;
		const match = backgroundColor.match(/rgb\((\d+), (\d+), (\d+)\)/);
		if (!match) {
			return;
		}
		const r = parseInt(match[1]);
		const g = parseInt(match[2]);
		const b = parseInt(match[3]);
		setIconColor(isRGBColorLight(r, g, b) ? "#000" : "#fff");
	}, [userGroup.color]);

	return (
		<div
			ref={ref}
			title={title}
			className={makeClassName(styles["user-group-icon"], className)}
			style={{ color: iconColor, "--color": userGroup.color, "--size": `${size}px`, ...style } as React.CSSProperties}
		>
			<Icon.Users weight="regular" className={styles["user-group-icon__icon"]} />
		</div>
	);
}
